/**
 * Central site URL constant. Reads from REACT_APP_SITE_URL at build time.
 * Fallback: current preview URL. Change via Vercel env var, or via
 * scripts/set-domain.sh before deploying.
 */
export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://iocri-research.preview.emergentagent.com";
